import ModalContainerModule from "../../../modules/modalContainer";
import VendorExpenseItems from "./vendorExpenseItems";

export default function ManageVendorExpenseItemsModal(props) {
  function handleCancel() {
    props.handleCancelClicked();
  }

  return (
    <ModalContainerModule
      size="sm"
      accept={props.saveVendorClicked}
      cancel={handleCancel}
      openModal={props.vendorExpenseItemsOpen}
      modalTitle="Vendor's Expense Items"
      acceptButtonText={"Save"}
      cancel2Text="back"
    >
      <VendorExpenseItems
        categoryAccountItems={props.categoryAccountItems}
        handleAddItems={props.handleAddItems}
      />
    </ModalContainerModule>
  );
}
